import { CONTACT_EMAIL } from "../lib/constants";

function LegalShell({ title, children }) {
  return (
    <div className="pt-28 max-w-3xl mx-auto px-5 pb-16">
      <h1 className="font-display font-black text-4xl md:text-5xl mb-8">{title}</h1>
      <div className="space-y-6 text-wyd-muted leading-relaxed">{children}</div>
    </div>
  );
}

const H = ({ children }) => <h2 className="font-display font-bold text-xl text-white mt-8 mb-3">{children}</h2>;

export function Privacy() {
  return (
    <LegalShell title="Privacy Policy">
      <p>La presente Privacy Policy descrive come WYD ("noi") raccoglie, utilizza e protegge i dati personali degli utenti in conformità al Regolamento (UE) 2016/679 (GDPR).</p>
      <H>Titolare del trattamento</H>
      <p>Il titolare del trattamento è WYD Milano. Per qualsiasi richiesta puoi scriverci a <a href={`mailto:${CONTACT_EMAIL}`} className="text-wyd-accent">{CONTACT_EMAIL}</a>.</p>
      <H>Dati raccolti</H>
      <p>Raccogliamo i dati che ci fornisci in fase di registrazione (nome, email) e una password conservata in forma cifrata. Registriamo inoltre gli eventi salvati tra i preferiti e le proposte di eventi inviate.</p>
      <H>Finalità del trattamento</H>
      <p>I dati sono utilizzati per gestire il tuo account, mostrarti i tuoi preferiti, moderare le proposte della community e migliorare il servizio. Non vendiamo i tuoi dati a terzi.</p>
      <H>Geolocalizzazione</H>
      <p>La funzione "Vicino a me" utilizza la posizione del dispositivo solo previo tuo consenso e unicamente per mostrarti gli eventi nelle vicinanze. La posizione non viene memorizzata sui nostri server.</p>
      <H>Cookie</H>
      <p>Utilizziamo esclusivamente cookie tecnici necessari al funzionamento del sito (ad esempio per mantenere la sessione di accesso).</p>
      <H>I tuoi diritti</H>
      <p>Hai diritto di accedere, rettificare o cancellare i tuoi dati, oltre a limitarne o opporti al trattamento. Per esercitare questi diritti contattaci all'indirizzo email sopra indicato.</p>
    </LegalShell>
  );
}

export function Terms() {
  return (
    <LegalShell title="Termini di Servizio">
      <p>Utilizzando WYD accetti i presenti Termini di Servizio. Ti invitiamo a leggerli con attenzione.</p>
      <H>Il servizio</H>
      <p>WYD è una piattaforma che aggrega e mostra eventi della vita notturna a Milano. Le informazioni sono fornite a titolo indicativo: ti consigliamo di verificare sempre orari, prezzi e disponibilità presso l'organizzatore dell'evento.</p>
      <H>Account utente</H>
      <p>Sei responsabile della riservatezza delle tue credenziali e di tutte le attività svolte tramite il tuo account.</p>
      <H>Contenuti generati dagli utenti</H>
      <p>Proponendo un evento garantisci di avere il diritto di condividerne le informazioni. Tutte le proposte sono soggette a moderazione e possono essere approvate o rifiutate a nostra discrezione. È vietato inserire contenuti illeciti, ingannevoli o offensivi.</p>
      <H>Limitazione di responsabilità</H>
      <p>WYD non è organizzatore degli eventi pubblicati e non è responsabile per eventuali variazioni, cancellazioni o disservizi legati agli stessi.</p>
      <H>Contatti</H>
      <p>Per qualsiasi domanda relativa ai presenti termini scrivi a <a href={`mailto:${CONTACT_EMAIL}`} className="text-wyd-accent">{CONTACT_EMAIL}</a>.</p>
    </LegalShell>
  );
}

export function About() {
  return (
    <LegalShell title="Chi Siamo">
      <p>WYD ("What You Doing?") nasce dall'amore per la notte milanese. Siamo un punto di riferimento per chi vuole scoprire i migliori DJ set, aperitivi, club, rooftop ed eventi della città.</p>
      <H>La nostra missione</H>
      <p>Rendere semplice e immediato trovare l'evento giusto per ogni serata. Dai Navigli a Isola, da Brera a Porta Venezia: la movida di Milano, tutta in un unico posto.</p>
      <H>Community</H>
      <p>WYD cresce grazie alla sua community. Chiunque può proporre un evento: il nostro team lo revisiona e, se in linea con lo spirito della piattaforma, lo pubblica per tutti.</p>
      <H>Scrivici</H>
      <p>Hai un evento da segnalare o vuoi collaborare? Contattaci a <a href={`mailto:${CONTACT_EMAIL}`} className="text-wyd-accent">{CONTACT_EMAIL}</a>.</p>
    </LegalShell>
  );
}
